import { Box, Button, Paper, styled, TextField } from "@mui/material";

export const PageContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  minHeight: "100vh",
  backgroundColor: "#eff7f8",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(3),
}));

export const StyledContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "100%",
  maxWidth: "1000px",
  maxHeight: "600px",
  height: "80vh",
  backgroundColor: "#0E9B9B",
  overflow: "hidden",
  position: "relative",
  borderRadius: theme.spacing(2),
  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    maxHeight: "none",
    height: "auto",
  },
}));

export const ImageContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  width: "50%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  color: "white",
  [theme.breakpoints.down("md")]: {
    width: "100%",
    padding: theme.spacing(3, 3, 1, 3),
  },
}));

export const LoginContainer = styled(Paper)(({ theme }) => ({
  width: "50%",
  borderTopLeftRadius: "40px",
  borderBottomLeftRadius: "40px",
  padding: theme.spacing(6),
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  backgroundColor: "white",
  [theme.breakpoints.down("md")]: {
    width: "100%",
    borderRadius: "40px 40px 0 0",
    padding: theme.spacing(4, 3),
  },
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#D9F4F2",
  color: "#0E9B9B",
  "&:hover": {
    backgroundColor: "#c4e9e6",
  },
  borderRadius: "4px",
  fontWeight: "bold",
  padding: "8px 16px",
}));

export const PasswordField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#E0E0E0",
    },
    "&:hover fieldset": {
      borderColor: "#0E9B9B",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#0E9B9B",
    },
  },
});

export const LoginStyle = {
  boxOn: { textAlign: "center", mb: 2 },
  boxTwo: { display: "flex", flexDirection: "column", alignItems: "center" },
  boxThree: { width: 80, mb: 2 },
  typographyBold: { fontWeight: "bold" },
  boxFore: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    mt: 2,
  },
  boxFive: { width: "80%", maxHeight: 200, borderRadius: 4 },
  typographyOne: { fontWeight: "bold", textAlign: "center", mt: 1 },
  boxSix: { padding: 3 },
  typographyTwo: { fontWeight: "bold", textAlign: "center", mb: 2 },
  textSecondary: { mb: 3, textAlign: "center" },
  formField: { mb: 2 },
  typographyThree: { fontWeight: "medium" },
  boxSeven: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  fontMedium: { fontWeight: "medium" },
  forgotPassword: { color: "#0E9B9B", fontSize: "0.875rem" },
  inputField: { borderRadius: 1 },
  rememberMeContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 3,
  },
  checkbox: {
    color: "#0E9B9B",
    "&.Mui-checked": { color: "#0E9B9B" },
    padding: "4px",
  },
  formControlLabel: { mr: 0 },
  footerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    pt: 2,
    borderTop: "1px solid #eee",
  },
  signUpLink: { color: "#0E9B9B", fontWeight: "medium" },
  socialIconsContainer: { display: "flex", gap: 1 },
  iconButton: { color: "#0E9B9B" },
};
